import { Box, Container } from "@mui/material";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";
import Description from "../../../../common/description/description.components";
import Title from "../../../../common/title/title.components";
import aboutPhoto from "../../../../assets/images/about-photo.webp";
import StyledWrapper from "./about-section.styled";

type Title = {
  label: string;
  color: string;
};

const AboutSection = () => {
  const { t } = useAppTranslation();
  const titles = t("aboutTedxCsikszereda.title", { returnObjects: true }) as Title[];
  return (
    <StyledWrapper id="about-us">
      <Container className="about-content-holder">
        <Box className="about-text">
          <Box className="about-title-box">
            {titles.map((title) => (
              <Title
                className="about-title"
                color={title.color}
                text={title.label}
                key={title.label}
              />
            ))}
          </Box>
          <Description className="about-description" text={t("aboutTedxCsikszereda.description")} />
        </Box>
        <Box className="about-photo-wrap">
          <img className="about-photo" src={aboutPhoto} alt="TEDxCsíkszereda" />
        </Box>
      </Container>
    </StyledWrapper>
  );
};

export default AboutSection;
